import Vue from 'vue';
import Router from 'vue-router';
import { AuthenService } from '@/services/authen.service';

Vue.use(Router);

const authenService = new AuthenService();

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: '',
      component: () => import('@/views/layout/Layout.vue'),
      beforeEnter: authenService.authRequire,
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import('@/views/Home.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/proposaldetail',
          name: 'proposaldetail',
          component: () => import('@/views/ProposalDetail.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/osusumedetail',
          name: 'osusumedetail',
          component: () => import('@/views/OsusumeDetail.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/coupondetail',
          name: 'coupondetail',
          component: () => import('@/views/CouponDetail.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/inspectorselect',
          name: 'inspectorselect',
          component: () => import('@/views/InspectorSelect.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/topicwork',
          name: 'topicwork',
          component: () => import('@/views/TopicsWork.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/liftuse',
          name: 'liftuse',
          component: () => import('@/views/LiftUse.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/shakenshohiyou',
          name: 'shakenshohiyou',
          component: () => import('@/views/ShakenShohiyou.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/createaccount',
          name: 'createaccount',
          component: () => import('@/views/CreateAccount.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/seibi',
          name: 'seibi',
          component: () => import('@/views/SeibiDetail.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/buhin',
          name: 'buhin',
          component: () => import('@/views/BuhinDetail.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/osusume',
          name: 'osusume',
          component: () => import('@/views/OsusumeCategory.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/seibi-buhin-link',
          name: 'seibiBuhinLink',
          component: () => import('@/views/SeibiBuhinLink.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/modeldetail',
          name: 'modeldetail',
          component: () => import('@/views/ModelDetail.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/seibi-extreme',
          name: 'seibiExtreme',
          component: () => import('@/views/SeibiExtreme.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/questionnairedetail',
          name: 'questionnairedetail',
          component: () => import('@/views/QuestionnaireDetail.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/inspect-comment',
          name: 'inspectcomment',
          component: () => import('@/views/InspectComment.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/buhin-extreme',
          name: 'buhinExtreme',
          component: () => import('@/views/BuhinExtremeLink.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/sp-osusume',
          name: 'sp-osusume',
          component: () => import('@/views/SpecialOsusume.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/menu-authority',
          name: 'menuAuthority',
          component: () => import('@/views/MenuAuthority.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/sync',
          name: 'sync',
          component: () => import('@/views/Sync.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/shaten',
          name: 'shaten',
          component: () => import('@/views/ShatenManagement.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/useresult',
          name: 'useresult',
          component: () => import('@/views/UseResult.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/fee',
          name: 'fee',
          component: () => import('@/views/FeeTable.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/tax-weight-request-result',
          name: 'taxweightrequestresult',
          component: () => import('@/views/TaxWeightRequestResult.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/check-exp-tables',
          name: 'checkExpTables',
          component: () => import('@/views/CheckExpTables.vue'),
          beforeEnter: authenService.staffRequire
        },
        {
          path: '/additional-options',
          name: 'additionalOptions',
          component: () => import('@/views/AdditionalOptions.vue'),
          beforeEnter: authenService.staffRequire
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/authentication/Login.vue'),
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter: authenService.onLogout,
    },
  ],
});

